function randomHex(bytes: number): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}

/** A fresh W3C traceparent (`00-<16B traceId>-<8B spanId>-01`). */
export function newTraceparent(): string {
  return `00-${randomHex(16)}-${randomHex(8)}-01`;
}

/**
 * W3C trace header for an outbound API call. Each request carries a client-minted
 * traceparent that the backend's OTel HTTP instrumentation adopts as the request
 * trace id — which the backend uses as its correlation id. So a request's id is
 * client-originated and consistent across the backend's logs/traces/audit ("one
 * thread", MD-01 §2.7). Sentry separately propagates its own `sentry-trace`/`baggage`
 * to the API origin; unifying the two ids awaits the full OTel Web SDK.
 */
export function traceHeaders(): Record<string, string> {
  return { traceparent: newTraceparent() };
}
